
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1271 1024","xmlns":"http://www.w3.org/2000/svg","width":"248.242","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M159.456 297.056c69.17 33.12 120.863 79.798 155.749 140.106 9.886 16.984 30.012 25.564 48.761 19.35a870.264 870.264 0 01268.985-42.124c92.793 0 184.42 14.335 268.95 42.124 18.75 6.073 38.84-2.366 48.727-19.35 35.062-60.308 86.93-106.845 155.784-140.106 46.713-22.457 75.526-70.76 75.526-122.629v-5.473c0-93.004-76.127-168.919-168.92-168.919h-760.17C159.88.035 83.93 76.126 83.93 168.955v5.472c-.141 51.87 28.67 100.03 75.526 122.629z","fill":"#fff"}}),_c('path',{attrs:{"d":"M1241.186 393.273a79.975 79.975 0 00-16.983-14.194 81 81 0 00-80.682-6.038c-73.62 35.733-121.04 89.685-144.414 163.27a42.83 42.83 0 01-22.88 25.74c-10.946 4.872-23.516 4.872-34.427.14-93.11-41.24-199.814-63.096-308.707-63.096-108.752 0-215.457 21.891-308.602 63.097-10.91 4.731-23.48 4.731-34.391-.141a42.018 42.018 0 01-22.916-25.74c-23.48-73.585-70.795-127.678-144.379-163.27a81.67 81.67 0 00-80.681 6.038c-6.674 4.449-12.711 9.321-16.843 14.194-36.65 42.548-30.719 107.304 8.828 146.886l50.28 50.245v215.174a63.556 63.556 0 0063.38 63.38h971.636a63.556 63.556 0 0063.415-63.38V590.545l50.245-50.245c38.84-39.723 44.772-104.48 8.121-147.027zM992.046 911.54h-84.53c-23.199 0-42.266 19.067-42.266 42.265s19.067 42.265 42.265 42.265h84.53c23.198 0 42.265-19.066 42.265-42.265s-19.067-42.265-42.265-42.265zm-633.694 0h-84.53c-23.198 0-42.265 19.067-42.265 42.265s19.067 42.265 42.265 42.265h84.53c23.198 0 42.265-19.066 42.265-42.265s-19.067-42.265-42.265-42.265z","fill":"#fff"}})])
          )
        }
      }
    